export const DANGER = "danger";
export const SUCCESS = "success";
export const WARNING = "warning";
export const STARTED = "started";


// WEBPACK FOOTER //
// ./src/components/dashboard/clients/enums/messageBoxTypes.js